import { render, staticRenderFns } from "./ArticlesPdfOptionDropDown.vue?vue&type=template&id=2bffb62a&"
import script from "./ArticlesPdfOptionDropDown.vue?vue&type=script&lang=js&"
export * from "./ArticlesPdfOptionDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports